import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["head", "links"]

  scroll(event) {
    if (this.hasLinksTarget && this.hasHeadTarget) {
      if (event.target.defaultView.pageYOffset > (this.headTarget.offsetHeight - 100)) {
        // Utiliser bg-secondary (bleu foncé) pour unsafe avec un peu de transparence
        this.linksTarget.classList.add("bg-secondary/90", "backdrop-blur-sm");
      } else {
        this.linksTarget.classList.remove("bg-secondary/90", "backdrop-blur-sm");
      }
    }
  }
}
